export const EMAIL_SENT = {
  "ar-ae": "شكرا لتواصلك معنا سنقوم بالرد عليك ف اقرب وقت",
  "en-gb": "We'll contact you to as soon as possible",
  "en-us": "We'll contact you to as soon as possible",
}
export const SUBSCRIBE = {
  "ar-ae": "شكرا لتواصلك معنا سنقوم بالرد عليك ف اقرب وقت",
  "en-gb": "We'll contact you to as soon as possible",
  "en-us": "We'll contact you to as soon as possible",
}
